import {match} from 'ts-pattern';

import {Nullish} from 'shared/web';

import {ActionsAlignment} from '../types/ActionsAlignment';

/**
 * Maps the semantic `actionsAlignment` prop to its CSS `justify-content` value.
 * Falls back to `center` when alignment is not provided.
 */
export const getActionsJustifyContent = (alignment: ActionsAlignment | Nullish) =>
  match(alignment)
    .with('left', () => 'flex-start' as const)
    .with('right', () => 'flex-end' as const)
    .otherwise(() => 'center' as const);
